/**
* 订单详情模板
**/ 

<template>
  <div class="detail">
    
    <el-button size="mini" icon="iconfont icon-Return"  @click="closeDialog"></el-button>
    <div class="detail-header box-bor box-mar10">
      <el-row>
        <el-col :span="4">
          <div class="grid-content"> 订单号：{{editForm.orderNo}}</div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content"> 合同编号：{{editForm.contractNo}}</div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content">下单时间：{{editForm.createTime}}</div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">订单类型：{{type(editForm.type)}}订单</div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">订单状态：{{state(editForm.state)}}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="grid-content">订单金额：￥{{editForm.amount}}</div>
        </el-col>
      </el-row>
    </div>

    <div class="detail-content box-mar10">

      <div class=" box-bor">
        <el-descriptions title="交付信息" :column="1" size="mini">
          <el-descriptions-item label="帐号">{{editForm.remark}}</el-descriptions-item>
        </el-descriptions>
      </div>
    </div>

    
    <!-- 续费 -->
    <div class="detail-order box-bor box-mar10" v-if="editForm.type==1">
      <el-descriptions title="续约信息" :column="4">
        <el-descriptions-item label="续约前订单号">{{editForm.oldOrderNo}}</el-descriptions-item>
        <!-- <el-descriptions-item label="续约时间" v-show="editForm.oldOrderEndDate">{{editForm.oldOrderEndDate}}</el-descriptions-item> -->
      </el-descriptions>
    </div>
    <!-- 升级 -->
    <div class="detail-order box-bor box-mar10" v-if="editForm.type==2">
      <el-descriptions title="扩容信息" :column="4">
        <el-descriptions-item label="扩容前订单号">{{editForm.oldOrderNo}}</el-descriptions-item>
        <!-- <el-descriptions-item label="升级前产品">50方</el-descriptions-item> -->
      </el-descriptions>
    </div>
    <!-- 扩容 -->
    <div class="detail-order box-bor box-mar10" v-if="editForm.type==4">
      <el-descriptions title="增购信息" :column="4">
        <el-descriptions-item label="增购前订单号">{{editForm.oldOrderNo}}</el-descriptions-item>
        <!-- <el-descriptions-item label="扩容前产品">50方</el-descriptions-item>
        <el-descriptions-item label="扩容前数量">10</el-descriptions-item> -->
      </el-descriptions>
    </div>

    <div class="detail-goods box-bor box-mar10">
      <div class="detail-goods-content">
        <h4>产品信息</h4>
        <el-table :data="editForm.orderServiceList" border style="width: 100%">
          <!-- <el-table-column prop="goodsCategory" label="产品分类" width="180">
          </el-table-column> -->
          <el-table-column prop="productName" label="产品名称" width="180">
          </el-table-column>
          <el-table-column prop="count" label="购买数量">
          </el-table-column>
          <el-table-column prop="amount" label="产品价格">
          </el-table-column>
          <el-table-column prop="startDate" label="服务开始日期">
          </el-table-column>
          <el-table-column prop="endDate" label="服务结束日期">
          </el-table-column>
        </el-table>
      </div>
    </div>

  </div>

</template>

<script>
// 导入组件
import {orderDetail} from '../../api/orderMG'

// 导出模块
export default {
  // 模块名字
  name: 'details',
  props: {
    id: Number
  },
  // 模块数据
  data() {
    //数据
    return {
      editForm: {
        nickname: null,
        email: '',
        username: '',
        company: '',
        ownerId: 0,
        orderNo: '',
        contractNo: '',
        type: 0,
        amount: 0.00,
        state: 1,
        oldOrderNo: '',
        remark: '',
        orderServiceList:[
          {
            id:'',
            productId: 0,
            productName: '',
            productCategory: '',
            count: 0,
            amount: 0.00,
            startDate: new Date,
            endDate: new Date,
            newOrderNo: '',
            serviceDate:[
              '',''
            ],
            path: []
          }
        ]
      },
      tableData: [
        {
          goodsCategory: '中目/基础计划/pro',
          goodsName: '100方',
          count: 1,
          goodsPrice: 3200.0
        }
      ]
    }
  },
  mounted() {
    if(this.id){
      orderDetail(this.id).then(res=>{
        if(res.code==0){
          this.editForm = res.data
        }
      })
    }
  },
  methods:{
    type(num) {
      switch (num) {
        case 0:
          return '新购'
        case 1:
          return '续约'
        case 2:
          return '扩容'
        case 3:
          return '降级'
        case 4:
          return '增购'
        default:
          return '新购'
      }
    },
    state(num) {
      switch (num) {
        case 0:
          return '订单中止'
        case 1:
          return '交易完成'
        case 2:
          return '订单终止'
        case 3:
          return '订单废弃'
        default:
          return '交易完成'
      }
    },
    closeDialog() {
      this.$emit('closeDialog',{show:false,index: 0})
    },
  }

}
</script>
// scoped 样式只在本组件使用
<style scoped>
/**
 * 导入css样式组件
 * @import "../assets/css/components/index.css";
 */
.detail {
  height: 100%;
}
/* .detail-header {
  border: 1px solid #eee;
} */
.detail-header .el-row {
  padding: 10px 10px;
  font-size: x-small;
  color: #333;
}
.detail-content {
  display: flex;
  /* height: 400px; */
  /* background-color: gold; */
}
.detail-content .el-descriptions-item {
  font-size: x-small;
  color: #333;
}
.detail-content .el-col {
  border: 1px solid gray;
}
.detail-content-l {
  width: 30%;
}
.el-descriptions {
  padding: 20px 20px;
}
.detail-content-r {
  width: 70%;
}

.detail .box-bor {
  border: 1px solid #eee;
  border-radius: 3px;
}
.detail .box-mar10 {
  margin: 10px 0 0 0;
}
.detail-order .el-descriptions-item {
  font-size: x-small;
  color: #333;
}
.detail-goods-content {
  padding: 0px 20px 10px;
}
.detail-footer {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0px 20px 40px;
}
.detail-footer button {
  position: fixed;
  bottom: 20px;
  z-index: 1000;
}
.el-tag-free {
  background-color: #f3f3f3;
  color: #666a6d;
  border: 1px solid #d4d9dd;
}
.el-descriptions-item__label:not(.is-bordered-label) {
  margin-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/order/details.vue